import { render, staticRenderFns } from "./OtherIncome.vue?vue&type=template&id=cfbfeca2&scoped=true&"
import script from "./OtherIncome.vue?vue&type=script&lang=js&"
export * from "./OtherIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbfeca2",
  null
  
)

export default component.exports